import {ProductListData} from '@/services/MockData/Products/ProductListData'
import {ProductListColConfig} from '@/services/MockData/Products/ProductListColConfig'

export const PRODUCTS_CONFIG = {
  PRODUCT_LIST: {
    endPoint: 'product-list',
    mockData: ProductListData,
  },
  PRODUCT_LIST_COL_CONFIG: {
    endPoint: 'product-list-column-config',
    mockData: ProductListColConfig,
  },
}
